const configs = {
    'timetrakker.pixelstrategiesinc.com': {
        logo: '/icons/pixel/icon.svg',
        title: 'Pixel Strategies',
        favicon: '/icons/pixel/favicon.svg',
        lognBack: '',
        loginBg: '/icons/pixel/pixel.svg',
    },
    'yourtimetrakker.qoo.studio': {
        logo: '/icons/gladstone/icon.svg',
        title: 'Gladstone Immersive',
        favicon: '/icons/gladstone/favicon.svg',
        lognBack: '/icons/gladstone/login_bg.mp4',
    },
    'timetrakker.qoo.studio': {
        logo: '/icons/qoo/icon.png',
        title: 'Qoo Studio',
        favicon: '/icons/qoo/favicon.png',
        lognBack: '/icons/qoo/login_bg.mp4',
    },
};

export function getSiteConfig() {
    const host = window.location.hostname;
    return (
        configs[host] || {
            logo: '/icons/gladstone/icon.svg',
            title: 'Gladstone Immersive',
            favicon: '/icons/gladstone/favicon.svg',
            lognBack: '/icons/gladstone/login_bg.mp4',
        }
    );
}
